export class Standort {
  constructor({ tageswechsel }: { tageswechsel: string | undefined }) {
    this.tageswechsel = tageswechsel;
  }

  tageswechsel: string | undefined;
}
